<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="GetSeznamDokumentov"
                           :selectorPermissions="selectorPermissions"
                           :disabled="loadingSeznamDokumentov"/>
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <p class="naslov">
          Pregled dokumentov
        </p>
        <div style="padding-top: 30px">
          <p class="primarna-barva-pisave">
            Na tej strani si lahko ogledate vse dokumente, ki so bili izdani v povezavi z vašo naročnino
            ali priključkom.<br/>
            Vse dokumente si lahko tudi prenesete na svoj računalnik v pdf obliki.
          </p>
        </div>
        <br/>
        <a style="display: none;" href="" :class="'dokumentiDownloadLink'" download=""/>
        <t2-table
          :data="seznamDokumentovVsi"
          :rows-per-page="8"
          v-loading="loadingSeznamDokumentov"
          width="100%"
          v-show="prikazTabele === '1'"
        >
          <el-table-column label="Datum in ura" prop="datum" width="200px">
            <template slot-scope="scope">
              <p>
                {{ (new Date(scope.row.date.date)) | formatiranDatumFromDate(true) }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="Tip dokumenta">
            <template slot-scope="scope">
              <p>
                {{ scope.row.title }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="Prenos" align="right" width="350px">
            <div slot-scope="scope" style="width: 100%;text-align: right;">
              <div style="height: 100%; text-align: right;" v-show="scope.row.loading">
                Prenos v teku
                <i class="fa fa-refresh fa-spin" style="font-size:15px">
                </i>
              </div>
              <div
                style="text-align: right"
                v-show="!scope.row.loading && scope.row.nalozeniDokumenti === null">
                <a href="javascript:void(0)"
                   @click="startPDFDownload(scope.row)"
                   class="primarna-barva dwnldLnk"
                   style="font-weight: normal">
                  <img src="/static/img/MojT2/Dokumenti/Icon-awesome-file-download.png">
                </a>
              </div>
              <div v-if="scope.row.nalozeniDokumenti !== null">
                <div
                  v-for="(item, index) in scope.row.nalozeniDokumenti"
                  class="d-flex"
                  :style="`${(index+1) === scope.row.nalozeniDokumenti.length ? '' : 'border-bottom: 1px dashed #dddddd; padding-bottom: 7px;'}`"
                >
                  <div style="flex:auto; margin-top: auto; text-align: left;">{{item.fileName}}</div>
                  <div style="text-align: right;">
                    <img src="/static/img/MojT2/Dokumenti/Icon-awesome-file-download.png" @click="downloadFile(item)" style="cursor: pointer;">
                  </div>
                </div>
              </div>
            </div>
          </el-table-column>
        </t2-table>
        <t2-table
          v-show="prikazTabele === '0'"
          :data="seznamDokumentovVsi"
          :rows-per-page="8"
          v-loading="loadingSeznamDokumentov"
          width="100%"
          :expand-row-keys="expandRowKeys"
          :row-key="row => row.id"
          @expand-change="IzbiraVrsticeZaPregledDokumenta"
        >
          <el-table-column label="Tip dokumenta">
            <template slot-scope="scope">
              {{ scope.row.title }}
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding: 20px">
                <div>
                  <p>
                      <span>
                        <b>
                          Datum:
                        </b>
                      </span>
                    {{ (new Date(scope.row.date.date)) | formatiranDatumFromDate(true) }}
                  </p>
                  <p>
                      <span>
                        <b>
                          Tip dokumenta:
                        </b>
                      </span>
                    {{ scope.row.title }}
                  </p>
                </div>
                <div>
                  <div style="height: 100%; text-align: left;" class="mt-4" v-show="scope.row.loading">
                    Prenos v teku
                    <i class="fa fa-refresh fa-spin" style="font-size:15px">
                    </i>
                  </div>
                  <div
                    style="text-align: left"
                    v-show="!scope.row.loading && scope.row.nalozeniDokumenti === null">
                    <a href="javascript:void(0)"
                       @click="startPDFDownload(scope.row)"
                       class="primarna-barva dwnldLnk d-flex"
                       style="font-weight: normal">
                      <div class="my-auto mr-2 open-sans-14pt"><b>Prenos</b></div>
                      <img src="/static/img/MojT2/Dokumenti/Icon-awesome-file-download.png">
                    </a>
                  </div>
                  <div v-if="scope.row.nalozeniDokumenti !== null">
                    <div
                      v-for="(item, index) in scope.row.nalozeniDokumenti"
                      class="d-flex"
                      :style="`${(index+1) === scope.row.nalozeniDokumenti.length ? '' : 'border-bottom: 1px dashed #dddddd; padding-bottom: 7px;'}`"
                    >
                      <div style="flex:auto; text-align: left;" class="my-1">{{item.fileName}}</div>
                      <div style="text-align: right;" class="my-auto">
                        <img src="/static/img/MojT2/Dokumenti/Icon-awesome-file-download.png" @click="downloadFile(item)" style="cursor: pointer;">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="clear: both"/>
            </template>
          </el-table-column>
        </t2-table>
        <InfoKomponentaDokumenti/>
        <div class="postavitev-povezave odmik-zgoraj manjsi-odmik">
          <a class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer"
             :href="cenikiT2Storitev" target="_blank">
            CENIKI T-2 STORITEV
          </a>
          <a class="el-button okvir-povezave tekst-povezave el-button--default" style="cursor: pointer"
             :href="cenikiT2Telefonije" target="_blank">
            CENIKI T-2 TELEFONIJE
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from 'vue'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {DatePicker, Button, Select, Option, Table, TableColumn, Pagination, Collapse} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {povezave} from '../../../../assets/js/Povezave/povezave'
import InfoKomponentaDokumenti from './InfoKomponentaDokumenti'
import T2Table from '../../../UIComponents/T2Table.vue'

Vue.use(Pagination)
export default {
  name: 'Dokumenti',
  mixins: [SirinaOkna],
  data() {
    return {
      clientAgent: null,
      seznamPrikljuckov: [],
      loadingSeznamDokumentov: false,
      seznamDokumentov: [],
      seznamDokumentovVsi: [],
      dolzinaSeznamaDokumentov: null,
      idStranka: '',
      nalaganjePDF: 0,
      nalaganjeDokumenta: null,
      seznamPodatkov: [],
      expandRowKeys: [],
      mejnaSirinaTabela: 1440,
      prikazTabele: '1',
      selectorPermissions: ['STRANKE'],
      cenikiT2Storitev: povezave.BASE_URL_CENIKI_T_2_STORITEV,
      cenikiT2Telefonije: povezave.BASE_URL_CENIKI_T_2_TELEFONIJE
    }
  },
  components: {
    T2Table,
    InfoKomponentaDokumenti,
    'IzbirnikStranke': IzbirnikStranke,
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Collapse.name]: Collapse,
    [Pagination.name]: Pagination
  },
  mounted() {
    this.clientAgent = new ClientAgent()
    this.SirinaOknaPresegaVrednostTabela
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
    IzbiraVrsticeZaPregledDokumenta(row) {
      const id = row.id
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    async startPDFDownload(row) {
      if (row.nalozeniDokumenti === null) {
        row.loading = true
        try {
          let response = await this.clientAgent.makeRequest(
            'dokumenti/prikaziDokument',
            {id: row.id, idStranka: Number.parseInt(this.idStranka)},
            'GET'
          )
          row.nalozeniDokumenti = response.data
          if (row.nalozeniDokumenti.length === 1){
            this.downloadFile (row.nalozeniDokumenti[0])
          }
        } catch (e) {
          e.duration = 0
          this.ShowErrorMessage(e)
        }
        row.loading = false
      }
    },
    downloadFile (file) {
      let dlnk = document.getElementsByClassName('dokumentiDownloadLink')[0]
      let doc = 'data:application/octet-stream;base64,' + file.content
      dlnk.href = doc
      dlnk.download = file.fileName
      dlnk.click()
    },
    GetSeznamDokumentov(prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.idStranka = prenosniParamIdStranka
        this.loadingSeznamDokumentov = true
        let param = ['idStranka=' + prenosniParamIdStranka]
        this.clientAgent.postWsRequest(
          this,
          'dokumenti/pridobiDokumente',
          param,
          null,
          'SetSeznamDokumentov',
          'ErrSeznamDokumento',
          120000
        )
      }
    },
    SetSeznamDokumentov(podatki) {
      podatki.data.forEach((item) => {
        item.loading = false
        item.nalozeniDokumenti = null
      })
      this.seznamDokumentovVsi = podatki.data
      this.loadingSeznamDokumentov = false
    },
    ErrSeznamDokumento (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
      this.loadingSeznamDokumentov = false
    }
  }
}
</script>
<style scoped src="../../../../../static/css/MojT-2/dokumenti.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Dokumenti.vue